
import React, { useEffect, useState } from 'react';
import { listenTeams } from '../firebase';
import { t } from '../i18n';

export default function Scoreboard(){
  const [teams, setTeams] = useState([]);
  useEffect(()=>{
    const unsub = listenTeams(setTeams);
    return () => unsub();
  }, []);

  return (
    <div>
      <ul className="list-group">
        {teams.length === 0 && (
          <li className="list-group-item text-muted">{t('noTeams')}</li>
        )}
        {teams.map(team=> (
          <li key={team.id} className="list-group-item d-flex justify-content-between align-items-center">
            <span>{team.name}</span>
            <span className="badge bg-primary rounded-pill">{team.points || 0}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
